// extracted by css-extract-rspack-plugin
export default {"Summary":"x1YzukSWdMJQ0zpE","Marker":"X7PKfycoAOtCTh1U"};